import { useContext } from 'react'
import { SearchContext } from '../containers/contexts/search'

export const useAccountDetails = () => {
  const {
    accountDetailsState,
    accountOwnerState,
    correspondentState,
    getAccountDetails,
    getCorrespondent,
    getAccountOwners,
  } = useContext(SearchContext)
  return {
    accountDetailsState,
    accountOwnerState,
    correspondentState,
    getAccountDetails,
    getCorrespondent,
    getAccountOwners,
  }
}
